import { render, staticRenderFns } from "./AddResourcesd.vue?vue&type=template&id=50a129ae&"
import script from "./AddResourcesd.vue?vue&type=script&lang=js&"
export * from "./AddResourcesd.vue?vue&type=script&lang=js&"
import style0 from "./AddResourcesd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports